export function getSubject(type) {
	let subject, previewText;

	if (type === 'welcomeEmail' || type === 'confirmEmail') {
		subject = 'Please confirm your e-mail address';
		previewText = 'Action Required - Please confirm your email';
	}
	if (type === 'viewingRequest') {
		subject = 'You have a viewing request';
		previewText = 'You have a viewing request';
	}
	if (type === 'bookingRequest') {
		subject = 'You have a new booking';
		previewText = 'Great News! You have a new booking';
	}
	if (type === 'bookingRequestGuest') {
		subject = 'Your booking request has been sent to your host';
		previewText = 'Great News! Your booking is shared with host';
	}
	if (type === 'bookingConfirmedToHost') {
		subject = 'You have a new booking from pleXpad';
		previewText = 'Booking Details';
	}
	if (type === 'bookingConfirmedToGuest') {
		subject = 'Your pleXpad booking has been confirmed';
		previewText = 'Your pleXpad booking has been confirmed';
	}
	if (type === 'bookingDeclinedToGuest') {
		subject = 'Your booking request is declined by your host';
		previewText = 'We are sorry, your request has been declined';
	}
	if (type === 'bookingExpiredGuest') {
		subject = 'Your booking request is expired';
		previewText = 'We are sorry, your request has expired';
	}
	if (type === 'bookingExpiredHost') {
		subject = 'Your booking has expired';
		previewText = 'Your booking has expired';
	}
	if (type === 'cancelledByHost') {
		subject = 'Your booking has been cancelled by the host';
		previewText = 'Your booking is cancelled';
	}
	if (type === 'cancelledByGuest') {
		subject = 'Your booking has been cancelled by the tenant';
		previewText = 'Your booking is cancelled';
	}
	if (type === 'completedGuest') {
		subject = 'Please Write a Review for your pleXpad Booking';
		previewText = 'Please Write a Review for your pleXpad Booking';
	}
	if (type === 'completedHost') {
		subject = 'Please write a review for your guest';
		previewText = 'Action Required! Write a Review';
	}
	if (type === 'forgotPasswordLink') {
		subject = 'Reset your Password';
		previewText = 'Please reset your Password';
	}

	if (type === 'message') {
		subject = 'You have a new message';
		previewText = 'You have a new message';
	}

	if (type === 'inquiry') {
		subject = 'You have a new enquiry';
		previewText = 'You have a new enquiry';
	}

	if (type === 'documentVerification') {
		subject = 'Documents Verification Status';
		previewText = 'Documents Verification Status';
	}
	if (type === 'contact') {
		subject = 'Customer Support Notification';
		previewText = 'You have received a customer support notification';
	}
	if (type === 'reportUser') {
		subject = 'Notification for a user violation';
		previewText = 'Notification for a user violation.';
	}
	if (type === 'bookingPreApproval') {
		subject = 'Your booking has been pre-approved';
		previewText = 'Booking pre-approved';
	}

	if (type === 'banStatusServiceStatusBanned') {
		subject = 'Your account has been disabled';
		previewText = 'Your account has been disabled';
	}
	if (type === 'banStatusServiceStatusUnBanned') {
		subject = 'Your account has been enabled';
		previewText = 'Your account has been enabled';
	}
	if (type === 'contactSupport') {
		subject = 'Customer Support';
		previewText = 'Customer Support';
	}
	if (type === 'userFeedback') {
		subject = 'Customer Feedback';
		previewText = 'Customer Feedback';
	}

	return {
		subject,
		previewText
	};
}


// WEBPACK FOOTER //
// src/core/email/template/subjects.js